export default __webpack_public_path__ + "static/media/landscaping-5.10ca337d.webp";